{
    "404": {
      "text": "404",
      "title": "Page Not Found",
      "subTitle": "We are sorry but the page you requested for was not found.",
      "button": "Go Back"
    },
    "customise_experience": {
        "add_more": "Add More",
        "celebratory_dates": "Celebratory Dates (Optional)",
        "customise_experience": "Customise Your Experience",
        "greetings": "Greetings",
        "language_preference": "Language Preference (Optional)",
        "your_birthday": "Your Birthday",
        "add_preferences": "Add Preferences (Optional)"
    },
    "atHotelWelcome": {
        "Welcome": "Welcome to",
        "Check_photo": "Check-in with a photo",
        "Explore_Redeem_Benifites": "Explore Hotel and Redeem Benefits"
    },
    "athotelExplore": {
        "title": "Explore Hotel and Redeem Benefits",
        "Hotel_video_view": "Hotel Video - 360° View",
        "Need_Assistance": "Need Assistance at the Hotel?",
        "Contact_club_Marriot": "Contact our Relationship Manager",
        "Fine_Dinning": "Dining",
        "Health_And_Rejuvenation": "Health and Rejuvenation",
        "Luxary_Stay": "Stay",
        "create_a_memory": "Create a Memory",
        "check_in_photo": "Check-in with a Photo"
    },
    "enroll_for_property": {
        "discount": "Discount",
        "gst": "GST",
        "gst_information": "GST Information (Optional)",
        "gst_invoice_receipt": "A GST Receipt cum Invoice shall be sent to",
        "gst_invoice_receipt_without_transaction": "A GST Receipt cum Invoice and Receipt shall be sent to",
        "gst_invoice_without_receipt": "A Receipt cum Invoice shall be sent to",
        "gst_invoice_without_receipt_without_transaction": "A Receipt cum Invoice shall be sent to",
        "hotel": "Hotel",
        "level": "Level",
        "net_price": "Net Price",
        "or": "Or",
        "pay_now": "Pay Now",
        "paid": "Paid",
        "price": "Price",
        "promo_code_applied": "Promo Code Applied",
        "registered_company": "Registered Company Name",
        "registered_email": "Your Registered Email ",
        "save_to_profile": "Save details to My Profile",
        "total_price": "Total Price",
        "welcome_to_marriott": "Welcome to {{brandName}}",
        "your_membership_is": "Your Membership Number is",
        "dear": "Dear",
        "activation_link": "An activation link has been sent via Email and SMS.",
        "wantToEnableFingerprint": "Do you want to enable Face ID or Fingerprint Sensor to Login?",
        "fingerprintFastEasy": "Fingerprint Sensor is a fast and easy way to log into your account.",
        "enableFingerprint": "Enable",
        "addGstInformation": "Add New GST",
        "enableFaceID": "Do you want to enable Face ID to Login?",
        "faceIDFastEasy": "Face ID is a fast and easy way to log into your account.",
        "enableFace": "Enable Face ID",
        "pay_with_ecash": "Pay with Experience Certificate",
        "totalEcash": "Total Experience Certificate Value",
        "balancePay": "Balance to Pay",
        "paymentUnsuccessfullHeader": "Payment Unsuccessful!",
        "paymentUnsuccessfullMessage": "We could not process your payment at the moment. We request you to try again.",
        "paymentAwaitingHeader": "Payment Awaiting",
        "paymentAwaitingMessage": "Payment will be completed in 24 hours. For immediate assistance, you may contact us at +91 11 43169658 or email us at contactus@gourmetclub",
        "paymentPendingHeader": "Payment Aborted/Pending",
        "paymentpendingMessage": "In case of any deduction from account, deducted amount will be credited in your bank account within 7 working days. You may contact us at +91 11 43169658 or email us at contactus@diningprivilege.com for any assistance."
    },
    "branch": {
        "branch_Message": "Invalid Membership ID",
        "branch_Message_Reservation": "You seem to have requested a reservation from a different membership account. Please switch your account to edit the reservation request.",
        "branch_Message_Renew": "You seem to have requested a membership renewal from a different account. Please switch your account to renew your membership.",
        "welcoming_rc_popup": "We look forward to welcoming you today!"
    },
    "login": {
        "enter_email": "Enter Email",
        "enter_mobile_number": "Enter Mobile number",
        "enter_password": "Enter Password",
        "forgot_password": "Forgot Password?",
        "login_delaration": "I consent to the use of my personal data by TLC and its program partners and hotel partners to send offers or promotions to me via Email, telephone, messages or mail, consistent with the communication preferences I select from time to time.",
        "login_with_email": "Login with Email",
        "login_with_mobile": "Login with Mobile number",
        "select_membership": "Select a membership",
        "submit": "Submit",
        "proceed": "Proceed",
        "valid_through": "Validity",
        "reset_password": "Reset Password",
        "set_new_password": "Set New Password",
        "confirm_password": "Confirm Password",
        "characters": "8-20 Characters",
        "lowercase": "1 Lowercase Character",
        "uppercase": "1 Uppercase Character",
        "number": "1 Number",
        "no_username": "The password should not be your user name, Email or Mobile number",
        "re_enter_password": "Re-enter Password",
        "change_password": "Change Password",
        "specialCharacter": "1 Special Character",
        "leaveMessage": "Leave a Message",
        "successfullyChangedPassword": "You have successfully changed your password. Login with your new password.",
        "Login_with_OTP": "Login with OTP",
        "OTP_has_been_sent": "An OTP has been sent to your registered mobile number"
    },
    "membership_home": {
        "view_all": "View All",
        "expiry": "days to expiry",
        "valid": "Validity ",
        "at": " at ",
        "reactivate_Membership": "Re-activate Your Membership",
        "renew_Now": "Renew Now",
        "upcoming_ReserveHeader": "Upcoming Reservations",
        "celeb_DatesHeader": "Celebration Dates",
        "no_ReserveText": "There are no upcoming reservations.",
        "add_CelebText": "+ Add Celebratory Date",
        "gift_MembershipText": "Gift a Membership",
        "buyMembership_NoCardBenefit": "Buy a membership to enjoy yearlong card benefits.",
        "no_content": "We are processing your request",
        "visitor": "Visitor",
        "visitor_card": "Join Now",
        "gift_Upload": "Upload Photo",
        "gift_Photo": "Add your photo to help us personalise your experience.",
        "guest_user_modal_txt": "This benefit is not available for Guests. Join our membership program.",
        "guest_user_modal_btn": "Become a Member",
        "termsConditions": "Terms & Conditions",
        "selectCity": "Please select a city.",
        "recentSearch": "Recent Search",
        "selectCityPlaceholder": "Enter City",
        "giftMembership": "Gift a Membership",
        "giftDescription": "Gift friends or family a Gourmet Club membership and offer them luxurious dining and stay experiences. You may even schedule it to reach them on a special day.",
        "giftNow": "Gift Now",
        "alreadyRegistered": "Already registered?",
        "notRegisteredYet": "Not registered yet?",
        "login": "Login",
        "signUp": "Sign up",
        "guestMembership": "for free as a Guest User to gift a membership."
    },
    "password": {
        "enter_new_password": "Create Password",
        "enter_new_password_required": "Please follow the password policy.",
        "password_should_match": "Passwords entered do not match. Please try again.",
        "password_already_set": "Password has already been set for this account. Please Login."
    },
    "privacy_statement": {
        "confirm": "Confirm",
        "proceed": "Proceed",
        "declaration": "Declaration",
        "no_data_found": "The information, including personal data, provided by you for Gourmet Club is collected by TLC DigiTech Pvt. Ltd.",
        "privacy_statement": "Privacy Statement",
        "goodMorning": "Good Morning",
        "goodAfternoon": "Good Afternoon",
        "goodEvening": "Good Evening",
        "noDataFound": "The information, including personal data, provided by you for Gourmet Club is collected by TLC DigiTech Pvt. Ltd.",
        "agree": "I Agree"
    },
    "query": {
        "call": "Call",
        "chat_now": "Chat Now",
        "email": "Email",
        "giftMembershipQuery": "If you wish to gift multiple memberships, please connect with our Contact Centre.",
        "loginQuery": "For Login related queries",
        "forgotAfterLogin": "For password related queries",
        "membershipQuery": "If you wish to purchase more than one membership, please connect with our Contact Centre.",
        "reactivationQuery": "For re-activation related queries",
        "renewalQuery": "For renewal related queries",
        "referralQuery": "For referral related queries",
        "serviceQuery": "Connect with our Concierge to know more",
        "activationRelatedQuery": "For activation related queries",
        "signupQuery": "For Sign up related queries",
        "chat": "Chat",
        "chatAll": "Our Membership Specialist is available from 9:30 AM to 6:30 PM EAT. Please leave your feedback at contactus@gourmetclub.co.ke",
        "gotIt": "Got It",
        "knowMore": "Know More",
        "readTC": "Read T&C",
        "thankYou": "Thank You",
        "reservation": "Connect with our Concierge to know more"
    },
    "register_user": {
        "OTP_will_be_sent": "An OTP will be sent to your registered Mobile number and Email.",
        "enter_email": "Enter Email",
        "email": "Email",
        "enter_name": "Enter Name",
        "name": "Name",
        "first_name_accepts_characters_only": "Invalid First Name",
        "last_name_accepts_characters_only": "Invalid Last Name",
        "enter_mobile_number": "Enter Mobile number",
        "mobile_number": "Mobile number",
        "mr": "Mr",
        "please_enter_a_valid_email": "Please enter a valid Email",
        "please_enter_a_valid_mobile_number": "Please enter a valid Mobile number",
        "please_share_your_details": "Please Share Your Details",
        "proceed": "Proceed",
        "verified": "Verified",
        "enter_membership_number": "Enter Membership Number",
        "first_name": "First Name",
        "last_name": "Last Name",
        "first_name_required": "Please enter First Name",
        "last_name_required": "Please enter Last Name",
        "mobile_number_required": "Please enter Mobile number",
        "email_required": "Please enter Email",
        "membership_number": "Membership Number",
        "activate_membership": "Please enter a valid Membership Number.",
        "invalid_membership": "This Membership Number is invalid.",
        "enableFaceIDFingerprint": "Enable Face ID / Fingerprint Sensor for Login",
        "enterEmailId": "Enter Email ",
        "reEnterEmail": "Re-Enter Email",
        "please_re_enter_email": "Please re-enter the Email",
        "leavePersonelMessage": "Leave a personal message or include a video.",
        "leavePersonelMessageGiftMembership": "Leave a personal message.",
        "type_a_message": "Type a message",
        "agree": "I Agree",
        "type_here": "Type here..."
    },
    "setup_profile": {
        "enter_name": "Enter Name",
        "name": "Name",
        "setup_your_profile": "Setup Your Profile",
        "upload_photo_msg": "Add your photo to confirm identity and customise your experience.",
        "discount": "Discount Applied"
    },
    "signup_program_benefits": {
        "discount_applied": "Discount Applied",
        "key_features": "Key Features",
        "promo_code": "Promo Code",
        "select_city": "Select City",
        "select_country": "Select Country",
        "select_level": "Select Level",
        "select_preferred_hotel": "Select Preferred Hotel",
        "skip": "Skip",
        "welcome": "Welcome",
        "spouse": "Spouse Membership",
        "viewBenefit": "View Benefit",
        "unlockBenefit": "Proceed",
        "enterPromocode": "Enter your Promo Code or continue as a Guest.",
        "selectPreferedHotel": "Please select your preferred {{brandName}} hotel to enable us to update you on the latest offers and promotions."
    },
    "spouse_membership": {
        "complimentary_membership": "You are entitled to a complimentary Spouse Membership.",
        "first_name": "First Name",
        "last_name": "Last Name",
        "membership_at_a_special_price": "Your benefits come with a membership for the spouse at a special price of",
        "spouse_membership": "Spouse Membership",
        "activation_link": "an activation link",
        "sent_to_email": "has been sent via Email and SMS",
        "mobile_already": "This Mobile number already exists.",
        "email_already": "This Email already exists.",
        "proceed": "Proceed to Pay",
        "okay": "OK",
        "spouse_creation": "Dear {{memberName}}, the membership details has been sent via Email and SMS to {{spouseFirstName}} {{spouseLastName}}.",
        "spouse_creation_without_transaction": "Dear {{memberName}}, an activation link has been sent via Email and SMS to {{spouseFirstName}} {{spouseLastName}}.",
        "renew_spouse": "Renew Membership",
        "renew_spouse_membership": "Renew Spouse Membership",
        "transactionNumber": "Your transaction number is {{transactionNumber}}.",
        "spouse_renewal_msg": "Your payment is successful and the spouse membership for {{spouseFirstName}} {{spouseLastName}} has been renewed and the benefits are available on their Membership page.",
        "spouse_renewal_msg_without_transaction": "The spouse membership for {{spouseFirstName}} {{spouseLastName}} has been renewed and the benefits are available on their Membership page.",
        "spouseMembershipAlert": "You cannot {{action}} membership as you are the Spouse Member. Please ask the Primary Member to renew your membership or connect with our Contact Centre.",
        "validEmailMobile": "This Email and Mobile number already exists."
    },
    "app_benefits": {
        "select_fav_hotel": "Select Your Favourite Hotel",
        "membership_program": "of the {{brandName}} membership program.",
        "video_tag_support": "Your browser does not support the video tag."
    },
    "tabs": {
        "activites": "Activities",
        "chat": "Chat",
        "home": "Home",
        "membership": "Membership",
        "profile": "Profile",
        "Benefits": "Benefits",
        "subscription": "Subscription"
    },
    "unlock_benefits": {
        "program_benefits": "Program Benefits",
        "unlock_benfits": "Proceed",
        "key_feature": "Key Features",
        "benefitsLocked": "Your benefits have not been unlocked. Login to unlock your benefits."
    },
    "welcome": {
        "title": "Title",
        "activate_membership": "Activate Membership",
        "login": "Login",
        "signup": "Sign up",
        "description1": "Curated Collection of Experiences and Benefits",
        "description2": "Buy and Gift Unique Experiences at {{brandName}} Hotels",
        "description3": "Customized Offers, Promotions, Events and more.",
        "description4": "Digital Membership and Instant Reservations",
        "description5": "Participating {{brandName}} Hotels.",
        "leadTerms": "By offering the content above, I give permission to {{brandName}} to make contact with me to receive more information and agree to the <a target='_blank' href='{{termsLink}}'>{{terms}}</a> and the <a target='_blank' href='{{privacyLink}}'>{{privacy}}</a> on the website.",
        "terms": "Terms of Membership",
        "privacy": "Privacy Policy",
        "termsHashUrl": "/terms-of-use",
        "privacyHashUrl": "https://www.tlcgroup.com/privacy-policy",
        "knowMore": "Know More",
        "submit": "Submit",
        "message": "Dear {{userName}}, <br> <br> Thank you for visiting the {{brandName}} website. <br> <br> We have received your request. One of our Associates will connect with you within 24 business hours. <br><br> Yours sincerely, <br> Team {{brandName}}",
        "partner_code_msg": "Enjoy a host of benefits with {{Brand Name}}.",
        "contactsuccessmsg": "Dear {{userName}}, <br> <br> Thank you for visiting the {{brandsName}} website. <br> <br> We have received your request. One of our Associates will connect with you within 24 business hours. <br><br> <span class='sincerBox'>Yours sincerely, <br> Team {{brandsName}}</span>"
    },
    "profile": {
        "salutation": "Salutation",
        "title": "Profile",
        "of_your_profile_is_complete": "of your profile is complete",
        "updateProfile": "Update Profile",
        "wallet": "Card Wallet",
        "settings": "Settings",
        "notifications": "Notifications",
        "contactUs": "Contact Us",
        "feedback": "Feedback",
        "faqs": "FAQs",
        "aboutUs": "About Us",
        "log_out": "Log out",
        "enterValidGST": "Please enter a valid GST number.",
        "enterValidGstDetails": "Please enter valid GST details.",
        "my_birthday": "My Birthday",
        "my_anniversary": "My Anniversary",
        "update_my_birthday": "Update My Birthday",
        "update_my_anniversary": "Update My Anniversary",
        "enterValidPincode": "Please enter a valid Pin Code.",
        "addBirthday": "Add Birthday",
        "addAnniversary": "Add Anniversary",
        "countrygstmismatching": "The entered GST number and the selected State does not match.",
        "countryPincodeMismatching": "The entered Pin Code does not match the selected State."
    },
    "settings": {
        "disclaimer": "Disclaimer",
        "communication_preferences": {
            "title": "Communication Preferences",
            "voice": "Voice",
            "sms": "SMS",
            "Whatsapp": "WhatsApp"
        },
        "email_preferences": {
            "title": "Email Preferences"
        },
        "device_preferences": "Device Preferences",
        "enableLock": "Enable App Lock",
        "staySignedIn": "Stay Signed In",
        "message": "Please note we would continue to send transactional messages through Notifications to enable us to service your membership. To disable transactional messages we request you to connect with our Contact Centre.",
        "appVersion": "App Version",
        "deleteAccount": "Delete my Account"
    },
    "notifications": {
        "message": "Please note we would continue to send transactional messages through Notifications to enable us to service your membership. To disable transactional messages we request you to connect with our Contact Centre."
    },
    "contact_us": {
        "connect_with_us": "Connect with us",
        "help_desk": "Contact Centre",
        "give_a_missed_call": "Give a Missed Call",
        "connect_with_hotel": "Connect with us on Social Media",
        "facebook": "Facebook",
        "instagram": "Instagram",
        "twitter": "X",
        "whatsApp": "WhatsApp",
        "emailSubject": "{{brandName}} Contact Us",
        "emailMessage": "Dear Team {{brandName}},"
    },
    "feedback": {
        "share_feedback": "Share Your Feedback",
        "share_your_experience": "Share Your Experience",
        "membership": "Membership",
        "application": "Application",
        "hotel": "Hotel",
        "rate_feedback": "Rate Feedback",
        "send_feedback": "Send Feedback",
        "go_to_home": "My Membership Page",
        "type_feedback": "Type Feedback",
        "feedback_category": "Feedback Category",
        "alreadySubmitted": "You have already submitted the feedback. Thank you!",
        "rateAndShare": "Rate and Share Experience",
        "thankYouForFeedback": "Thank you for your feedback.",
        "weAreDelighted": "We are delighted that you had a great experience and we look forward to welcoming you back soon.",
        "weWillShare": "We will share your feedback with the team.  Your feedback motivates all of us to do even better next time.",
        "shareMemory": "Share a Memory",
        "shareFeedback": "Share Feedback"
    },
    "update_profile": {
        "title": "Update Profile",
        "your_profile_is": "Your profile is",
        "complete": "complete",
        "edit_profile": "Update Photo",
        "change_password": "Change Password",
        "add_nationality": "Add Nationality",
        "add_address": "Add Address",
        "add_landline_number": "Add Landline Number",
        "add_loyalty_program": "Add Loyalty Program Details",
        "add_business_details": "Add Business Details",
        "update_fav_hotel": "Update Favourite Hotel",
        "update_favourite_hotel": "Update Your Favourite Hotel",
        "add_spouse_card": "Add Spouse Card Details",
        "spouse_card": "Spouse Card",
        "activated": "Activated",
        "celebratory_dates": "Celebratory Dates",
        "name": "Name",
        "relationship": "Relationship",
        "occasion": "Occasion",
        "date": "Date",
        "add_more_celebratory_date": "Add More Celebratory Dates",
        "your_preferences": "Your Preferences",
        "language_preferences": "Language Preferences",
        "cuisine_preferences": "Cuisine Preferences",
        "lifestyle_preferences": "Lifestyle Preferences",
        "holiday_preferences": "Holiday Preferences",
        "payment_settings": "Payment Settings",
        "manage_saved_cards": "Manage Saved Cards",
        "delete": "Delete",
        "add_another_card": "Add Another Card",
        "auto_payment_setup": "Auto Payment Setup",
        "monthly": "Monthly",
        "quarterly": "Quarterly",
        "annual": "Annual",
        "select_payment_method": "Select Payment Method",
        "preferred_currency": "Preferred Currency",
        "gst_details": "GST Details",
        "gold": "Gold",
        "other": "Relationship:",
        "otherOccassion": "Occasion:",
        "update": "Update",
        "got_it": "Got It",
        "update_hotel_request": "Your request is being updated and will reflect in your membership account in 2 business days.",
        "otherRelation": "Other Relation",
        "otherOccassions": "Other Occasion"
    },
    "add_address": {
        "title": "Add Address",
        "addAddress": "Add Address",
        "editAddress": "Edit Address",
        "address_type": "Address Type",
        "select_address_type": "Select Address Type",
        "country": "Country",
        "select_country": "Select Country",
        "address_line_1": "Address Line 1",
        "address_line_2": "Address Line 2",
        "city": "City",
        "property": "Property",
        "select_city": "Select City",
        "pincode": "Pin Code",
        "update": "Update",
        "add": "Add",
        "done": "Done",
        "hotel": "Hotel",
        "level": "Level"
    },
    "add_business_details": {
        "title": "Add Business Details",
        "addBusinessDetails": "Add Business Details",
        "editBusinessDetails": "Edit Business Details",
        "designation": "Designation",
        "company_name": "Company Name",
        "profession": "Profession",
        "select_profession": "Select Profession",
        "update": "Update"
    },
    "gst_details": {
        "addGST": "Add GST Details",
        "editGST": "Edit GST Details",
        "gst_number": "GST Number",
        "registered_company_name": "Registered Company Name",
        "address_line_1": "Address Line 1",
        "address_line_2": "Address Line 2",
        "country": "Country",
        "select_country": "Select Country",
        "state": "State",
        "select_state": "Select State",
        "city": "City",
        "select_city": "Select City",
        "pincode": "Pin Code",
        "update": "Update",
        "add_details": "Add Details"
    },
    "add_landline_number": {
        "title": "Add Landline Number",
        "addLandline": "Add Landline Number",
        "editLandline": "Edit Landline Number",
        "country_code": "Country Code",
        "select_country_code": "Select Country Code",
        "area_code": "Area Code",
        "select_area_code": "Select Area Code",
        "landline_number": "Landline Number",
        "update": "Update"
    },
    "add_loyalty": {
        "title": "Add Loyalty Program Details",
        "addLoyalty": "Add Loyalty Program Details",
        "editLoyalty": "Edit Loyalty Program Details",
        "program_name": "Program Name",
        "select_a_program": "Select a Program",
        "membership_number": "Membership Number",
        "delete": "Delete",
        "add_more": "Add More",
        "update": "Update"
    },
    "add_nationality": {
        "title": "Add Nationality",
        "nationality": "Nationality",
        "select_nationality": "Select Nationality",
        "update": "Update"
    },
    "add_spouse_card": {
        "title": "Add Spouse Details"
    },
    "edit_email_mobile": {
        "update_email": "Update Email",
        "update_mobile": "Update Mobile number",
        "enter_otp": "Enter OTP",
        "enter_otp_email": "Please enter the OTP sent to your email.",
        "enter_otp_mobile": "Please enter the OTP sent to your mobile."
    },
    "new_celebratory": {
        "addCelebratory": "Add Celebratory Date",
        "editCelebratory": "Edit Celebratory Date"
    },
    "giftMembership": {
        "title": "Gift a Membership",
        "country": "Country",
        "city": "City",
        "hotel": "Hotel",
        "level": "Level",
        "promo": "Promo Code",
        "proceed": "Proceed to Gift"
    },
    "giftDetail": {
        "title": "Gift Details",
        "details": "Enter Name and Contact Details",
        "firstName": {
            "required": "Please enter First Name.",
            "pattern": "Please enter a valid First Name."
        },
        "lastName": {
            "required": "Please enter Last Name.",
            "pattern": "Please enter a valid Last Name."
        },
        "email": {
            "required": "Please enter Email",
            "pattern": "Please enter a valid Email."
        },
        "mobile": {
            "required": "Please enter Mobile number.",
            "pattern": "Please enter a valid Mobile number.",
            "validPhoneNumber": "Please enter a valid Mobile number."
        },
        "payNow": "Pay Now",
        "proceesdNow": "Proceed",
        "requestActivation": "Request Activation",
        "payment_title": "Your payment is successful.",
        "payment_title_without_transaction": "Your payment is successful.",
        "payment_para": "A confirmation Email and an SMS has been sent to {{giftedMemberFirstName}} {{giftedMemberLastName}} with details to activate the membership along with your message.",
        "uploading_video": "Uploading video",
        "video_uploaded": "Video uploaded successfully",
        "giftNow": "Gift Now",
        "choosePreferredDateAndTime": "Choose preferred date and time",
        "preferredDate": "Preferred date",
        "preferredTimeZone": "Preferred time ({{timeZone}})",
        "hours": "{{hours}} hours"
    },
    "searchOutlet": {
        "search": "Search a ",
        "reserve": "Select",
        "redeem": "Select",
        "book": "Select",
        "request": "Request a Reservation",
        "resturant": "Search a Restaurant",
        "hotel": "Select a Hotel",
        "pool": "Select a Swimming Pool",
        "spa": "Select a Spa",
        "other": "Select an Outlet",
        "gym": "Select a Gym",
        "proceed": "Proceed",
        "searchOutlets": "Search Outlets",
        "selectOutlet": "Select Outlet"
    },
    "outletDetail": {
        "menu": "View Menu",
        "benefit": "Benefit",
        "certificate": "Certificate Benefits",
        "card": "Card Benefits",
        "menuImage": "Menu Image",
        "close": "Close",
        "description": "NA",
        "dine": "guests applauded the chef at {{outletName}}",
        "stay": "guests applauded our accommodation at {{outletName}}",
        "spa": "guests applauded our spa services at {{outletName}}",
        "pool": "guests applauded our pool services at {{outletName}}",
        "cardBenefit": "Card Benefit",
        "restaurant": "Restaurant",
        "Pool": "Pool",
        "accomodation": "Accommodation",
        "Spa": "Spa",
        "appDine": "Dine",
        "Benefit Redemption": "Benefit Redemption",
        "reviews": "Reviews"
    },
    "certificateDetails": {
        "title": "Certificate Details",
        "cardTitle": "Card Details",
        "redeem": "Redeem",
        "reserve": "Reserve",
        "book": "Book",
        "gift": "Gift Certificate",
        "add_to_Gift_cart": "Add to Gift Cart",
        "add_to_cart": "Add to Cart",
        "valid": "Validity",
        "downloadApp": "Download {{brandName}}",
        "site": "Take me to",
        "call": "Call Now",
        "archieve": "This certificate has been archived successfully.",
        "unarchieve": "This certificate has been unarchived successfully.",
        "resendGift": "Certificate details have been shared again successfully."
    },
    "cart": {
        "title": "Cart"
    },
    "membershipBenefit": {
        "title": "Membership Benefit",
        "noCard": "Card benefits are not available",
        "noCertificate": "Buy High Value Certificates",
        "validbenefit": "All participating {{BrandName}} hotels valid at",
        "noCertificateWithoutAction": "You may avail benefits by buying a {{brandName}} membership."
    },
    "dinningReservation": {
        "title": "Reservation",
        "update": "Update Reservation",
        "at": "at",
        "treatment": "Select Treatment",
        "therapy": "Therapy",
        "beauty": "Beauty Treatment",
        "other": "Other",
        "preferredDate": "Choose Date",
        "today": "Today",
        "tommorrow": "Tomorrow",
        "preferredTime": "Choose Time",
        "duration": "Select Duration",
        "guestNumber": "Select Number of Guests",
        "adultNumber": "Select Number of Adults",
        "celebration": "Tell us more about your celebration",
        "birthday": "Birthday",
        "anniversary": "Anniversary",
        "foodPreference": "Add Food Preferences",
        "beveragePreference": "Add Beverage Preferences",
        "specialRequest": "Special Request",
        "termsStatement": "I agree with the ",
        "termsAndCondition": "Terms and Conditions ",
        "conditionStatement": "of the benefit",
        "confirmReservation": "Confirm Reservation",
        "requestReservation": "Request Reservation",
        "back": "Back",
        "cont": "Continue",
        "got_it": "Got It",
        "call_Now": "Call Now",
        "continue": "Continue Reservation",
        "certificate_validation": "This benefit is not available on the selected date or time. Please check the terms of use accompanying this benefit. You may go back or continue without this benefit.",
        "two_time_validation": "We are unable to process this request. You may call the outlet to speak with them directly.",
        "tablePreferences": "Table Preferences",
        "valid_time_validation": "The outlet is not operational during these hours. Please select an alternate time or select another outlet.",
        "restricted_time_validation": "We are unable to confirm this reservation online. You may call the outlet or proceed with your reservation request. The outlet shall review your request and get back to you in 24 business hours.",
        "guest_validation": "This benefit is only valid for a maximum of two guests. You may proceed and settle the additional amount directly on departure.",
        "guestCountMinValidation": "This benefit is only valid for a minimum of {{count}} guest(s). You may proceed and settle the additional amount directly on departure.",
        "guestCountMaxValidation": "This benefit is only valid for a maximum of {{count}} guest(s). You may proceed and settle the additional amount directly on departure.",
        "guest_vali": "We are unable to confirm this reservation online. You may call the outlet or proceed with your reservation request. The outlet shall review your request and get back to you in 24 business hours.",
        "cancelReservationWhileModification": "Please note that this certificate is not available during the selected date or time. Please check the terms of use of this benefit. Please go back and modify or cancel this reservation and make a new reservation.",
        "selectDuration": "Duration",
        "tellUsMore": "Would you like to tell us more?",
        "guest": "Guest",
        "guests": "Guests",
        "adult": "Adult",
        "adults": "Adults",
        "kids": "Kids",
        "kid": "Kid",
        "pleaseSelectFutureDateTime": "Please select future date/time."
    },
    "staticMessages": {
        "success": "Success.",
        "error": "Something went wrong.",
        "genricErrorMessage": "We are customising your {{brandName}} experience."
    },
    "redeemBenefit": {
        "title": "Redeem Benefit",
        "titleGift": "Gift Certificates",
        "property": "Restaurant Name",
        "guest": "Guest",
        "guests": "Guests",
        "adult": "Adult",
        "kid": "Kid",
        "proceedToCheckIn": "Proceed to check in",
        "checkIn": "Proceed To Redeem",
        "spaModal": "Please redeem the benefit at the Spa.",
        "stayModal": "This benefit is subject to a confirmed room reservation in the same room category as per the terms of this benefit. Please redeem this benefit after checking in to the hotel.",
        "dineModal": "Please redeem the benefit upon arrival. You may need to present a valid photo ID to avail the benefit.",
        "poolModal": "Please redeem the benefit at the Swimming Pool.",
        "gotIt": "Got It",
        "proceed": "Proceed",
        "redeemptionErrorForTime": "Redemption can only be done one hour before and after the time of reservation.",
        "outletName": "Outlet Name",
        "admit": "Admit"
    },
    "redeemBenefitOTP": {
        "subTitle": "Redeeming Benefit",
        "trouble": "Having trouble with OTP?  ",
        "scan": " Scan QR Code",
        "confirm": "Proceed",
        "giftcertifcate": "Gifting Certificate...",
        "giftto": "Gift To",
        "otp": "OTP will be sent to your registered Mobile number and Email."
    },
    "redeemBenefitQR": {
        "title": "Redeem Benefits",
        "qrCode": "Show QR Code on the screen to redeem certificate.",
        "troubleWithQR": "Trouble with QR Code? Please give your Membership Number and certificate details that you wish to redeem to the hotel staff. You will get an Email confirming your redemption.",
        "done": "Done",
        "regenerate_para": "Click on regenerate button to generate new QR Code",
        "regenerate": "Regenerate"
    },
    "redeemBenefitCertificate": {
        "title": "Redeem Benefits",
        "benefit": "Benefit Redeemed",
        "certificate": "Certificate Code",
        "certificateName": "Certificate Name",
        "confirmation": "You will receive an Email as confirmation.",
        "create_a_memory": "Create a Memory",
        "Membership Number": "Membership Number",
        "Transaction Number": "Transaction Number",
        "gotoMyMembership": "My Membership page"
    },
    "redeemBenefitRating": {
        "experience": "Rate Your Experience",
        "compliment": "Compliment the Chef",
        "review": "Review",
        "submit": "Submit",
        "reviewCheckboxContent": "I allow {{brandName}} to share this review."
    },
    "tableReserve": {
        "reserve": "Reservation Confirmed",
        "poolrequest": "Reservation Requested",
        "dinetable": "Table Reserved",
        "confirmation": "Confirmation Number",
        "requestNumber": "Request Number",
        "wallet": "+ Add to Wallet",
        "calender": "+ Add to Calendar",
        "addTo": "Add to",
        "appleWallet": "Apple Wallet",
        "redeem": "Redeem at ",
        "poolSpa": "Announce your arrival to the hotel staff to redeem your benefit. We will hold your table for 15 minutes over the expected arrival time. An Email has been sent to you with your reservation and preferences details.",
        "reservation": "Your Reservation Preferences",
        "celebration": "Celebration",
        "food": "Food Preferences",
        "beverage": "Beverage Preferences",
        "request": "Special Request",
        "chef": "Connect with Our Chef",
        "invite": "Want to Invite Guests?",
        "sendInvite": "Send Invites",
        "assistance": "Need Assistance at the Hotel?",
        "cancel": "Cancel",
        "modify": "Modify",
        "home": "Home Page",
        "inviteDescription": "You can send personalised invites to all your guests with reservation details to join you at the venue.",
        "delete_reservation": "Cancel Reservation",
        "delete_reservation_para": "Are you sure you want to cancel this reservation?",
        "yes": "Yes",
        "no": "No",
        "January": "January",
        "February": "February",
        "March": "March",
        "April": "April",
        "May": "May",
        "June": "June",
        "July": "July",
        "August": "August",
        "September": "September",
        "October": "October",
        "November": "November",
        "December": "December",
        "Monday": "Monday",
        "Tuesday": "Tuesday",
        "Wednesday": "Wednesday",
        "Thursday": "Thursday",
        "Friday": "Friday",
        "Saturday": "Saturday",
        "Sunday": "Sunday",
        "contact": "Contact"
    },
    "tabsMembership": {
        "benefits": "Benefits",
        "membershipBenefits": "Membership Benefits",
        "subscriptionBenefits": "Subscription Benefits",
        "membershipTitle": "My Membership",
        "termsOfUse": "Terms of Use",
        "certificateTitle": "My Certificates",
        "upgradeMembershipTitle": "Upgrade Your Membership",
        "historyTitle": "History",
        "viewAll": "View All",
        "view": "View",
        "cardsWallet": "Cards Wallet",
        "validThru": "Validity",
        "certificateTypes": {
            "dining": "Dining",
            "luxuryStay": "Stay",
            "health": "Wellness",
            "other": "Other"
        },
        "receiveGiftCertificate": "Enter Code to Receive Benefit",
        "noBenefit": "You may avail benefits by buying a certificate or a {{brandName}} membership.",
        "viewLess": "View Less",
        "cardBenefits": "Card Benefits",
        "yourMembershipBenefits": "Your {{plan}} Membership Benefits",
        "membershipCertificates": "Certificates",
        "certificateHistory": "Certificate History",
        "doMoreWithUs": "Do More with Us",
        "Proceed": "Proceed",
        "referAFriend": "Refer a Friend",
        "planACelebration": "Plan a Celebration",
        "businessMeetings": "Business Meetings",
        "ecashExperience": "Your Experience Certificates",
        "viewBenefitTerms": "View Terms of Use",
        "goBack": "Go Back",
        "tapBenefitRedeem": "Tap to open Benefit and Redeem."
    },
    "cardBenefit": {
        "cardBenefitsTitle": "Card Benefits",
        "validThru": "Validity",
        "termsCondition": "T&C",
        "since": "Since",
        "validAt": "Valid at",
        "reserve": "Reserve",
        "redeem": "Redeem",
        "book": "Book",
        "certificateTypes": {
            "dining": "Dining",
            "health": "Health",
            "other": "Other"
        },
        "terms": "T&C",
        "termsAndContion": "Card Terms and Conditions"
    },
    "loader": {
        "globalMsgWait": "Please wait...",
        "globalMsgLoad": "Loading...",
        "fetchData": "Please wait...",
        "uploadImage": "Uploading information...",
        "uploadVideo": "Uploading video...",
        "login": "Logging in...",
        "profile": "Fetching profile data...",
        "updateProfile": "Uploading information...",
        "updatingDefault": "Updating...",
        "logout": "Logging out",
        "validatePromo": "Validating Promo Code...",
        "activityLoadMsg": "Loading activities...",
        "sendingOtp": "Sending OTP...",
        "verifyingOtp": "Verifying OTP...",
        "verifyEmail": "Verifying Email...",
        "verifyMobile": "Verifying Mobile number...",
        "unlockBenefit": "Please wait...",
        "online": "You are now online",
        "offline": "You are now offline"
    },
    "toastMsg": {
        "imgUploadFail": "We were unable to upload your image. Please try again.",
        "imageUploadSucc": "Your image has been uploaded successfully.",
        "checkInternet": "Please connect to the Internet to use this website.",
        "mobileAlreadyExist": "This Mobile number already exists. Please Login.",
        "emailAlreadyExist": "This Email already exists. Please Login.",
        "dearGuest": "Dear Guest,",
        "enter_valid_email": "Please enter a valid Email.",
        "enter_email_or_mobile": "Please enter Mobile number or Email to proceed.",
        "enterMobile": "Please enter Mobile number.",
        "enterEmail": "Please enter Email. ",
        "otpToProceed": "Please enter OTP.",
        "requestOtp": "Request OTP",
        "somethingWrong": "Something went wrong.",
        "validPromo": "Please enter a valid Promo Code.",
        "profileMobileExist": "This Mobile number already exists. Please enter a different Mobile number.",
        "profileEmailExist": "This Email already exists. Please enter a different Email.",
        "initApp": "We are customising your experience. This may take a few seconds.",
        "videoError": "You cannot upload more than 50 MB.",
        "ok": "OK",
        "invalidPromo": "This Promo Code is not valid",
        "busyMicrophone": "Unable to access Microphone. It may be in use by some other application.",
        "unableAccessMicrophone": "No audio received. Please check your microphone and try again."
    },
    "otp": {
        "requestOTP": "Request OTP",
        "resendOTP": "Resend OTP",
        "mobileOtpMessage": "An OTP will be sent to your mobile number",
        "emailOtpMessage": "An OTP will be sent to your email",
        "enterEmailOtpMessage": "Please enter the OTP sent to your email"
    },
    "chat": {
        "chatUnavailable": "Hello! Thank you for connecting with us.  All our Membership Specialists are busy at the moment and will join you shortly.",
        "chatTime": "Welcome to our Contact Centre.  You have reached us after office hours. Please leave a message for us to connect with you.",
        "ChatSucuss": "We have made a note of your request. Our Membership Specialist will contact you within 24 business hours.",
        "ChatSucussHeader": "Request submitted."
    },
    "sendInvite": {
        "title": "Invite Guests",
        "subTitle": "Invite your guests for this event",
        "numberOfInviteSent": "Invites Sent",
        "oneInviteSent": "Invite Sent",
        "modalPara": "Enjoy your meal with your guest(s) at hotelName on",
        "modalbutton": "Got it",
        "button": "Share Invite",
        "addMore": "Add More",
        "at": "at",
        "errorMsg":"Please enter valid details. Details of the invitee cannot be same as that of the host."
    },
    "planWith": {
        "title": "Plan with {{hotelName}}",
        "travelExperiences": "Travel Experiences",
        "country": "Country",
        "city": "City",
        "property": "Hotel",
        "hours": "Hours",
        "minutes": "Minutes",
        "signatureDishes": "Our signature dishes for secure delivery"
    },
    "socialEvents": {
        "title": "Social Events",
        "selectSocialEvent": "Select Social Event",
        "numberOfGuest": "Select Number of Guests",
        "selectDate": "Select Date",
        "selectTime": "Select Time",
        "submit": "Submit",
        "moreAboutCelebration": "Tell us more about your event",
        "selectCountryLabel": "Country",
        "selectPropertyLabel": "Hotel",
        "selectCityLabel": "City",
        "selectCountry": "Select Country",
        "selectCity": "Select City",
        "selectProperty": "Select Hotel",
        "selectLevel": "Select Level",
        "datesAreFlexible": "My dates are flexible",
        "gotIt": "Got It",
        "hotelWillContactYouIn24": "{{hotelName}} will connect with you within 24 business hours.",
        "planACelebration": "Plan a Celebration"
    },
    "businessMeeting": {
        "title": "Business Meetings",
        "selectMeeting": "Select Meeting Type",
        "moreAboutConference": "Tell us more about your meeting",
        "am": "AM",
        "pm": "PM"
    },
    "activitiesHub": {
        "title": "Activities Hub",
        "connectToKnowMore": "Connect to Know More",
        "contactMessage": "{{brandName}} will contact you in a while. Thanks.",
        "buttonText": "Done"
    },
    "personalServices": {
        "title": "Personal Services"
    },
    "cancelReservation": {
        "title": "Reservation Cancelled",
        "cancellation": "Cancellation Number",
        "info": "This reservation has been cancelled. If you have not cancelled this reservation, please connect with us."
    },
    "reactivate_Membership": {
        "upgrade": "Upgrade Membership",
        "view_benefit": "View Benefits",
        "renew_membership": "Renew Membership",
        "reactivate_membership": "Re-activate Membership",
        "reactivation_benefits": "Re-activation Benefits",
        "renewal_benefits": "Renewal Benefits",
        "renew_Payment_without_transaction": "Your payment is successful. The renewed membership benefits are available to view on your Membership Page.",
        "reactivate_Payment_without_transaction": "Your payment is successful. The updated benefits are available to view on your Membership Page.",
        "renew_Payment": "Your payment is successful. The renewed membership benefits are available to view on your Membership Page.",
        "reactivate_Payment": "Your payment is successful. The updated benefits are available to view on your Membership Page.",
        "featureDisabled": "This feature has been disabled for the Beta version of the website."
    },
    "partnerBenefit": {
        "title": "Partner Benefit"
    },
    "activitiesTab": {
        "title": "Activities",
        "upcomingReservation": "Upcoming Reservations",
        "noUpcomingReservation": "There are no upcoming reservations.",
        "startDate": "Start Date",
        "endDate": "End Date",
        "activityHistory": "Activity History",
        "noActivitiesFound": "There is no activity history.",
        "certificateLabel": "Certificate",
        "amount": "Amount",
        "certificateNumber": "Certificate Number",
        "transactionNumber": "Transaction Number",
        "certificateBenefitLabel": "Certificate Benefit",
        "numberOfPoints": "Number of Points",
        "promocode": "Promo Code",
        "outletAndProperty": "Outlet and Property",
        "amountSpent": "Amount Spent",
        "memberhsipTypeLabel": "Membership Type",
        "outletLabel": "Outlet Name",
        "benefitAvailed": "Benefit Availed",
        "pointsEarned": "Points Earned",
        "cancellationNumber": "Cancellation Number",
        "redemptionCodeLabel": "Redemption Code",
        "feedbackGiven": "Feedback Given",
        "profileUpdated": "Profile Updated",
        "membershipExpiryDate": "Membership Expiry Date",
        "numberOfPointsRedeemed": "Number of Points Redeemed",
        "membershipNumber": "Membership Number",
        "certificateExpiryDate": "Certificate Expiry Date",
        "membershipTypeLabel": "Membership Type",
        "at": "at",
        "showMore": "Show More",
        "showLess": "Show Less",
        "viewCheque": "View Cheque",
        "feedbackDetails": "Feedback Details",
        "rating": "Rating"
    },
    "orderIn": {
        "title": "Order-In",
        "country": "Country",
        "selectCountry": "Select Country",
        "noResultFound": "We are unable to retrieve the outlet details. Please try later or reach us at our Contact Centre.",
        "viewDetails": {
            "guestApplaud": "guests applauded the chef at "
        }
    },
    "cardWallet": {
        "buyAnotherMembership": "Buy Another Membership",
        "becomeMember": "Become a Member",
        "noMembershipPresent": "We are unable to retrieve your membership card.  Please reach us at our Contact Centre",
        "selectHotel": "Select Hotel",
        "pleaseEnterPromocode": "Please enter a valid Promo Code.",
        "pleaseApplyPromocode": "Please apply a valid Promo Code.",
        "update": "Update Membership",
        "buyAnother": "Buy a Membership",
        "giftMessage": "View Gift Message",
        "giftMessageNew": "Gift Received",
        "membershipViewGiftMessage": "View Gift Message",
        "membershipGiftReceived": "Gift Received"
    },
    "buyAnotherMembership": {
        "new_membership": "Your payment is successful. The membership is available under Cards Wallet.",
        "new_membership_without_transaction": "Your payment is successful. The membership is available under Cards Wallet.",
        "errorPurchase": "The total purchase amount may not exceed {{maxPayableAmount}}. Since your transaction exceeds the limit, we request you to please reach us at our Contact Centre to complete the transaction."
    },
    "ecash": {
        "title": "Experience Certificates (Ecash)",
        "chooseECashCertificate": "As you have opted to use an experience certificate, please make a selection to proceed."
    },
    "logout": {
        "title": "Log out",
        "message": "Are you sure you wish to log out?",
        "no": "No",
        "yes": "Yes"
    },
    "referralFriend": {
        "referalCode": "Your Referral Code",
        "referalShare": "Share",
        "referalCopy": "Copy",
        "referalwork": "How It Works?",
        "referalView": "View Your Conversion Status",
        "referalViewStatus": "Number of Referrals Made",
        "referalConversions": "Conversions",
        "referalCertificate": "Certificate(s) added from referral can be viewed on your Membership Page.",
        "referalcash": "Experience Certificate(s) received.",
        "referalSharePlease": "Successful paid references will entitle you to a benefit. Please connect with us at our Contact Centre.",
        "referalCopyClip": "Code copied to your clipboard",
        "referalMonth": "January, February, March, April, May, June, July, August, September, October, November, December",
        "referalHeader": "Refer a Friend",
        "referalShareMessage": "Become a {{brandName}} member by using the link {{websiteURL}} and avail exciting benefits at {{currentBrand}} hotels. Use the Referral Code {{referralCode}}.",
        "btnKeepwithMe": "Keep with Me",
        "btnGift": "Gift",
        "numberofReferralsMade": "Number of Referrals made",
        "gotIt": "Got It",
        "introduction": "Introduce your friends and family to the most indulgent dining, stay and wellness experiences through {{brandName}}."
    },
    "giftCertificate": {
        "Proceed": "Proceed to Gift",
        "Add": "+ Add More",
        "cart": "Cart",
        "selectGift": "Select Certificates to Gift",
        "buyGift": "Buy High Value Certificates",
        "contactDetailsGift": "Enter Name and Contact Details",
        "wordsGift": "100 words",
        "titlecount": "Certificate Count Details",
        "giftCertficateTo": "Experience Certificate(s) Gifted to",
        "giftCertficateDetails": " Gifted Certificate Details ",
        "giftCode": "Certificate Code",
        "certificateGifted": "Certificates Gifted",
        "confirmation": "They will receive an SMS and an Email with details to activate the gifted certificate.",
        "receive_gift_certificate": "Receive a Benefit",
        "enter_the_certificate_code_placeholder": "Enter the Code",
        "receive_gift_certificate_proceed": "Proceed",
        "receive_gift_certificate_otp_message": "An OTP has been sent on the registered Mobile number and Email of the person holding this certificate to confirm the transfer. The OTP is valid for 15 minutes. Once confirmed, this certificate will feature in your Membership page.",
        "receive_membershipextension_ecashbenefit_confirmed_message": "Your request is confirmed. An Email with the details has been sent to your registered Email ID.",
        "receive_gift_certificate_process_message": "You may use the same process to transfer the additional certificates.",
        "button_got_it": "Got It",
        "dear": "Dear {{userName}},",
        "sincerely": "Sincerely,",
        "messageFrom": "Message from",
        "certificatesGifted": "Certificates Gifted",
        "certificatesGiftedTo": "Certificate(s) Gifted to",
        "giftedCertificateDetails": "Gifted Certificate Details",
        "smsEmailAsConfirmation": "You will receive an Email as confirmation.",
        "validTill": "Valid till",
        "personaliseGift": "Personalise Your Gift",
        "shareVideoGift": "Share a message and add a personalised video with the gift",
        "shareGift": "Share a message with the gift",
        "shareVideoGiftMembership": "Share a message with the gift",
        "videoSpecifications": "The video should be within 50 MB and should only be sent to someone who knows you and will accept a gift from you.",
        "words": "Words",
        "confirmDetails": "Confirm Details",
        "certificateGiftedTo": "Your certificate is being gifted to",
        "noMessageAvailable": "There is no message with this gifted experience.",
        "giftCertificate": "Gift Certificate"
    },
    "buyCertificate": {
        "title": "Buy Experience Certificates",
        "addToCart": "Add to Cart",
        "goToCart": "Go to Cart",
        "addCertificate": "Add Certificate",
        "checkout": "Check-out",
        "payment_success": "Your payment is successful.",
        "payment_success_without_transaction": "Your payment is successful.",
        "payment_success_description": "The newly purchased Experience Certificate(s) {{placeS}} {{areOrIs}} now placed on your Membership Page and are ready to be gifted.",
        "payment_success_button": "Proceed",
        "noCertificate": "Currently, the <Program Name> Program does not offer any certificate for sale. Please check again after few days.",
        "cartEmpty": "Your cart is empty.",
        "used": "Used",
        "gifted": "Gifted",
        "archived": "Archived",
        "lapsed": "Lapsed",
        "giftedTo": "Gifted to",
        "on": "on",
        "resend": "Resend",
        "retrieveCertificate": "Retrieve Certificate",
        "certificateRetrieved": "This certificate has been retrieved and placed on your Membership Page. ",
        "blankArchiveMsg": "To archive a certificate, click on your certificate and tap the (-) icon on the top right corner. All the archived certificates can be retrieved as per requirement.",
        "blankLapsedMsg": "Your certificates which have not been used and are beyond the date of expiry will be visible in this tab.",
        "multiPGmessage": "Please make another transaction to purchase this certificate."
    },
    "specialOffer": {
        "title": "My Special Offers"
    },
    "updateCeleb": {
        "title": "Update Celebratory Date",
        "firstNameErr": "Please enter a valid First Name.",
        "lastNameErr": "Please enter a valid Last Name.",
        "done": "Done",
        "delete": "Delete"
    },
    "marriott_experience": {
        "title": "Experience Certificates",
        "comming_soon": "Coming Soon",
        "marriott_ecash": "You have no Experience Certificates.  You may refer a friend to buy a membership and earn Experience Certificates.",
        "marriott_refer": "Refer Now"
    },
    "signup_promo_code": {
        "invalid_promo": "Invalid Promo Code or Referral Code",
        "apply": "Apply",
        "proceed": "Proceed",
        "continue_as_guest": "Continue as a Guest",
        "invalidFormat": "The Promo Code format is invalid."
    },
    "auto_populate": {
        "header_text": "Auto Populated Message",
        "message": "Allow {{brandName}} to read the message below and enter code?",
        "buttonText": "Allow"
    },
    "enroll_model": {
        "apply_text": "Apply",
        "applied_text": "Applied",
        "proceed": "Proceed",
        "discount_applied": "Discount applied",
        "referral_code_validated": "This Referral Code has been validated.",
        "call_for_promocode": "Call for a Promo Code",
        "become_member": "Become a Member",
        "buy_membership_text": "Buy a Membership",
        "gift_membership": "Gift a Membership",
        "gift_membership_text": "Gift a Membership",
        "chooseFromProfile": "Choose from profile",
        "happyBirthday": "Happy Birthday",
        "celebrateWithUs": "Celebrate With Us",
        "havePromocode": "I have a Promo Code.",
        "startTyping": "Start typing",
        "whoseAreYouCelebrating": "What occasion are you celebrating?",
        "pleaseArrangeFlowers": "Please arrange for a bouquet of flowers."
    },
    "postcard": {
        "atTheHotel": {
            "title": "{{brandName}}",
            "description": "Enjoying the {{currentBrand}} Experience at {{propertyName}} #{{brandTag}}"
        },
        "feedback": {
            "title": "{{brandName}}",
            "description": "Enjoying the {{currentBrand}} Experience at {{propertyName}} #{{brandTag}}"
        },
        "redemption": {
            "title": "{{brandName}}",
            "description": "Enjoying the {{currentBrand}} Experience at {{propertyName}} #{{brandTag}}"
        },
        "checkInHotel": {
            "title": "{{brandName}}",
            "description": "{{firstName}} {{lastName}} checking-in at {{propertyName}}.  Enjoying the {{currentBrand}} Experience. #{{brandTag}}."
        },
        "createMemoryButton": "Create a Memory",
        "checkInHotelButton": "Check In with a Photo",
        "checkInHotelWelcomeMsg": "Checking in at {{propertyName}}.",
        "placeholderText": "Enter Name",
        "happy": "Happy",
        "birthday": "Birthday",
        "celebrating": "Celebrating",
        "anniversary": "Anniversary",
        "imageSaveMsg": "Your memory will be saved to gallery.",
        "imageSaveError": "Error saving image to gallery."
    },
    "promotion": {
        "offerEvents": {
            "selectCountryCity": "Please select country and city first.",
            "selectCity": "Please select city first.",
            "setDate": "Set Date",
            "price": "{{price}} + applicable taxes.",
            "guests": "{{applaudCount}} Guests",
            "noPromotions": " Promotions not found."
        },
        "unique": "Unique Experiences",
        "signature": "Signature Collections",
        "offer": "Promotions",
        "partner": "Partner Offers",
        "personalServices": "Personal Services",
        "activity": "Activities Hub",
        "visitorAlert": {
            "promotion": "This benefit is only available for Members.",
            "promotionButton": "Buy a Membership",
            "giftCertificate": "You have no certificates to gift. You may buy a certificate and gift.",
            "giftCertificateButton": "Buy a certificate"
        },
        "promotionDetail": {
            "buy": "Buy",
            "redeem": "Redeem",
            "reserve": "Reserve"
        },
        "noOutlets": "We are unable to retrieve the outlet details. Please try later or reach us at our Contact Centre."
    },
    "months": {
        "january": "January",
        "february": "February",
        "march": "March",
        "april": "April",
        "may": "May",
        "june": "June",
        "july": "July",
        "august": "August",
        "september": "September",
        "october": "October",
        "november": "November",
        "december": "December"
    },
   "configJson": {
	  "brandsName": "Gourmet Club",
	  "currentBrand": "Gourmet Club",
	  "appName": "Gourmet Club"
	},
    "activities": {
        "certificatePurchased": "Certificate Purchased",
        "certificateGifted": "Certificate Gifted to",
        "pointsPurchased": "Points Purchased",
        "pointsEarned": "Points Earned",
        "membershipPurchased": "Membership Purchased",
        "membershipUpgraded": "Membership Upgraded",
        "membershipRenewed": "Membership Renewed",
        "membershipGifted": "Membership Gifted to",
        "membershipReactivated": "Membership Reactivated",
        "referralBenefitReceived": "Referral Benefit Received",
        "transaction": "Transaction",
        "cancelReservation": "Cancelled Reservation",
        "pointsRedeemed": "Points Redeemed",
        "feedback": "Feedback",
        "profileUpdate": "Profile Updated",
        "viewCheque": "View Cheque",
        "membershipLapsed": "Membership Lapsed",
        "lapsedCertificate": "Lapsed Certificate",
        "giftReceived": "Gift Received from",
        "signup": "Welcome to",
        "spouseMembershipAdded": "Spouse Membership Added",
        "cancelRedemption": "Cancelled Redemption"
    },
    "IonDateTimeMonth": {
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Apr",
        "may": "May",
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Aug",
        "sep": "Sep",
        "oct": "Oct",
        "nov": "Nov",
        "dec": "Dec"
    },
    "IonDateTimeFullMonth": {
        "jan": "January",
        "feb": "February",
        "mar": "March",
        "apr": "April",
        "may": "May",
        "jun": "June",
        "jul": "July",
        "aug": "August",
        "sep": "September",
        "oct": "October",
        "nov": "November",
        "dec": "December"
    },
    "IonDateTimeDays": {
        "sun": "Sun",
        "mon": "Mon",
        "tue": "Tues",
        "wed": "Wed",
        "thurs": "Thurs",
        "fri": "Fri",
        "sat": "Sat"
    },
    "IonDateTimeFullDays": {
        "sun": "Sunday",
        "mon": "Monday",
        "tue": "Tuesday",
        "wed": "Wednesday",
        "thurs": "Thursday",
        "fri": "Friday",
        "sat": "Saturday"
    },
    "paymentGateway": {
        "equityAlertHeader": "Payment failed!",
        "equityAlert": "Payment was not successful. Please try again."
    },
    "appRatePopup": {
        "title": "Would you mind rating %@?",
        "message": "It won’t take more than a minute and helps to promote our website. Thanks for your support!",
        "cancelButtonLabel": "No, Thanks",
        "laterButtonLabel": "Remind me later",
        "rateButtonLabel": "Rate Now"
    },
    "updatePopup": {
        "updateMessage": "To continue to use this website, we request you to update to the new version. This update is free.",
        "updateOkMessage": "To get this update now,<br> please select Ok.<br> This update is free.",
        "updateRequiredHeader": "Update Required",
        "updateOptionalHeader": "Update Available",
        "ok": "OK",
        "cancel": "Cancel",
        "update": "Update Now"
    },
    "mbowPage": {
        "title": "MBOW"
    },
    "subscription": {
        "select": "select",
        "now": "Now",
        "later": "Later",
        "choosePlan": "Choose Your Plan",
        "hotelTitle": "Hotel Specific Membership",
        "nationalTitle": "Subscription Program",
        "membershipDetail": "Membership Details",
        "subscriptionDetail": "Subscription Details",
        "reactivate_Subscription": "Reactivate Subscription",
        "buyAnotherSubscription": "Buy Another Subscription",
        "renew_Subscription": "Renew Subscription",
        "gift_Subscription": "Gift a Subscription",
        "scheduleSubscription": "Schedule Subscription",
        "subscriptionStartOn": "Your Subscription will start on",
        "scheduleSubscriptionInfo": "Your subscription will start on your chosen date.",
        "inValidPromoCodeForEmail": "This promocode is not valid for",
        "changePlan": "Change Plan",
        "membershipBenefits": "Membership Benefits",
        "Admit": "Admit",
        "Validity": "Validity",
        "TermsofUse": "Terms of Use",
        "Book": "Book",
        "Reserve": "Reserve",
        "Redeem": "Redeem"
    },
    "mbowDeliveryAddress": {
        "deleteHeader": "Delete Address?",
        "deleteMessage": "Are you sure you want to delete this address?",
        "deleteButtons": [
            "Cancel",
            "Delete"
        ]
    },
    "contactUs": {
        "termsStatement": "By offering the content above, I agree to the <a target='_blank' href='{{termsLink}}'>{{terms}}</a> and <a target='_blank' href='{{privacyLink}}'>{{privacy}}</a> on this website and give permission to {{brandName}} to make contact with me to share more information.",
        "terms": "Terms & Conditions",
        "privacy": "Privacy Policy",
        "termsHashUrl": "/terms-conditions",
        "privacyHashUrl": "/privacy-policy",
        "query": "Nature of Query",
        "title": "Title",
        "error": {
            "firstName": {
                "required": "Invalid First Name",
                "pattern": "Please enter a valid First Name."
            },
            "lastName": {
                "required": "Invalid Last Name",
                "pattern": "Please enter a valid Last Name."
            },
            "query": {
                "required": "Please select the nature of query."
            },
            "email": {
                "required": "Please enter Email",
                "pattern": "Please enter a valid Email."
            },
            "mobile": {
                "required": "Please enter Mobile number.",
                "pattern": "Please enter a valid Mobile number.",
                "validPhoneNumber": "Please enter a valid Mobile number."
            },
            "feedback": {
                "required": "Please share your feedback."
            }
        }
    },
    "oneTimeUseCertificateComponent": {
        "title": "One-Time Use Certificates",
        "tooltip": "Tap on the benefit to see detailed Terms of Use.",
        "certificate": "Certificate",
        "silver": "Silver",
        "gold": "Gold",
        "T&C": "Terms and Conditions apply"
    },
    "onGoingMebershipBenefitComponent": {
        "title": "Ongoing Membership Benefits",
        "subtitle": "Silver & Gold"
    },
    "paymentRedirectionMessage": "You are now being redirected to a secured payment gateway.",
    "participatingHotels": {
        "pageTitle": "Participating Hotels in Kenya"
    },
    "propertyDetails": {
        "viewBenefitsTitle": "View Benefits at Participating Hotels",
        "viewBenefitsSubtitle": "Elevate your dining and stay experiences with benefits at our participating hotels in Kenya.",
        "benefitsHeading": "Card Benefits"
    },
    "SEO":{
		"welcome":{
			"title":"Gourmet Club | Membership of Participating Gourmet Club Hotels in Kenya",
		    "metaName":"description",
		    "metaContent":"Unlock exclusive benefits with the Gourmet Club membership at participating Gourmet Club Hotels across Kenya. Enjoy special offers on dining, stay and more, for a memorable experience."
		},
        "disclaimer":{
			"title":"Gourmet Club | Disclaimer",
			"metaName":"description",
			"metaContent":"Read the Disclaimer for Gourmet Club. Understand the limitations, responsibilities, and legal aspects related to the membership and the use of associated services."
		},
		"paymentTerms":{
			"title":"Gourmet Club | Payment Terms",
			"metaName":"description",
			"metaContent":"Understand the Payment Terms for Gourmet Club membership. Learn about the payment policies, processes, and conditions for availing of exclusive offers and benefits."
		},
		"termsCondition":{
			"title":"Gourmet Club  Membership | Participating Gourmet Club Hotels in Kenya | Terms and Conditions",
			"metaName":"description",
			"metaContent":"Read the comprehensive Terms and Conditions for Gourmet Club membership. Understand the guidelines, member benefits, and rules for enjoying exclusive offers at participating Gourmet Club Hotels."
		},
		"termsOfUse":{
			"title":"Gourmet Club | Terms of Use",
			"metaName":"description",
			"metaContent":"Review the Terms of Use for the Gourmet Club website. Learn about the policies governing access, use, and limitations related to the Gourmet Club membership."
		},
		"membershipHome":{
            "title":"",
			"metaName":"description",
			"metaContent":""
		},
		"promotion":{
			"title":"Gourmet Club Membership | Gourmet Club Hotels | Partner Promotions",
			"metaName":"description",
			"metaContent":"Gourmet Club doesnt just provide gourmet dining and luxury hotel experiences at Gourmet Club Hotels but also brings to you exciting offers from our partner brands."
		},
		"partnerPromotion":
		{
            "title":"Gourmet Club Membership | Gourmet Club Hotels | Partner Promotions",
			"metaName":"description",
			"metaContent":"Gourmet Club doesnt just provide gourmet dining and luxury hotel experiences at Gourmet Club Hotels but also brings to you exciting offers from our partner brands."
		},
		"login":{
          "title":"Login to Gourmet Club | Exclusive Membership from Gourmet Club Hotels",
			"metaName":"description",
			"metaContent":"Sign up or log in to your Gourmet Club membership account to access exclusive benefits on dining, stays, wellness and more at participating Gourmet Club Hotels."
		},
		"privacyStatement":{
            "title":"Gourmet Club Membership | Gourmet Club Hotels | Privacy Statement",
			"metaName":"description",
			"metaContent":"Please refer to the Privacy Statement to know how we store and manage your personal data."
		},
		"property":{
            "title":"Welcome to Gourmet Club | Exclusive Membership from Gourmet Club Hotels",
			"metaName":"description",
			"metaContent":"The Gourmet Club membership is your doorway to gourmet dining and luxury hotel experiences at participating Gourmet Club Hotels in Kenya Enrol now."
		}
	},
       "welcomePage": {
      "title": "Experience Indulgence with Gourmet Club",
      "description": "Join the Gourmet Club membership and enjoy benefits on dining, accommodation and leisure experiences across all participating Gourmet Club Hotels in Kenya."
    },
	 "receiveBenefit": {
        "viewTitle": "Enter OTP to confirm transfer of the Gourmet Club Certificate. The OTP issued is valid for 15 minutes. If the OTP has expired, your friend will have to request for the transfer of the certificate again.",
        "buttonTitle": "Close",
        "successMsg": "OTP Submitted"
    },
    "paymentLink": {
        "header": "Please select Terms & Conditions",
        "validation": "Please enter valid data"

    }
	
  }
